<template>
  <dialogBar @on-close="close" v-if="config.show" :dialog-width="config.width">
    <div slot="header">{{config.title}}</div>
    <div class="dialog_publish_main" slot="main">
      <el-form ref="form" :model="formData" :rules="rules" label-width="80px">
        <el-form-item label="原密码" prop="OldPassward">
          <el-input size="mini" v-model="formData.OldPassward" onkeyup="value=value.replace(/[\u4e00-\u9fa5/\s+/]/ig,'')" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="Password">
          <el-input size="mini" v-model="formData.Password" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="ConfirmPassword">
          <el-input size="mini" v-model="formData.ConfirmPassword" show-password></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="info" size="mini" @click="close(false)">取消</el-button>
      <el-button type="primary" size="mini" @click="onSubmit()">确认</el-button>
    </div>
  </dialogBar>
</template>
<script>
import dialogBar from "./comment/dialogBar";

export default {
  components: {
    dialogBar: dialogBar
  },
  props: {
    config: {
      type: Object,
      default: {
        show: false,
        width: 800,
        title: "",
        type: 0, //0 创建，1 修改名称
        data: {}
      }
    }
  },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value.length < 6 || value.length > 16) {
        callback(new Error("密码长度不符！"));
      } else if (value !== this.formData.Password) {
        callback(new Error("两次输入密码不一致!"));
      }  else if (value === this.formData.OldPassward) {
        callback(new Error("新密码不能与原密码相同!"));
      } else {
        callback();
      }
    };
    return {
      formData: {
        OldPassward: "",
        Password: "",
        ConfirmPassword: ""
      },
      rules: {
        OldPassward: [
          { required: true, message: "请输入原密码", trigger: "blur" }
        ],
        Password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,30}$/, message: '密码必须8 - 30位，由数字，字母，特殊符号组成' }
        ],
        ConfirmPassword: [
          { required: true, validator: validatePass2, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    close() {
      this.config.show = false;
      this.$emit("close");
    },
    show() {
      this.formData = {
        OldPassward: "",
        Password: "",
        ConfirmPassword: ""
      };
      this.config.show = true;
      this.$emit("show");
    },
    onSubmit() {
      debugger;
      if(this.formData.OldPassward.trim()==""){
        this.$message.error("原始密码不能为空");
        return false;
      }
      let _this = this;
      this.$refs.form.validate(async valid => {
        if (valid) {
          let result = await this.$promission.post(
            "/api/Users/ChangePassword",
            _this.formData
          ); 
          this.$message("密码修改成功");
          _this.close();
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog_publish_main {
  padding-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/ChangePassword.vue